import api from '../api';

export const addUpdateGroup = (data) => api.post('/core/functions/addUpdateGroup', data);

export const archiveUnarchiveGroup = (data) => api.post('/core/functions/archiveUnarchiveGroup', data);

export const fetchGroups = (data) => api.post('/core/functions/fetchGroups', data);

export const fetchGroup = (data) => api.post('/core/functions/fetchGroup', data);
